export default __webpack_public_path__ + "static/40-2200734a8c8ed7730340f99aec2e836a.png";